import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    padding: 0 40px 32px 40px;
    font-family: 'Galano', 'Roboto', sans-serif, 'Helvetica Neue', sans-serif;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0 0 16px 0;
    }
  `}
`;

export const DataAndMetricsRow = styled.div`
  ${({ theme, autoColumns }) => css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (min-width: ${theme.v3.breakpoints.lg}) {
    display: grid;
    grid-template-columns: ${autoColumns ? 'auto' : '1fr auto'};
    gap: 40px;
  `}
`;
